export default [{
  id: 'limiting-the-number-of-promises-running-concurrently',
  type: 'article',
  title: 'Limiting the number of promises running concurrently.',
  date: '2018-01-31T17:43:44.487Z',
  tags: ['HowTo', 'Javascript'],
  contentShort: 'How to execute requests in parallel, but limiting the number concurent executions.',
},{
  id: 'a-serverless-content-management-system',
  type: 'article',
  title: 'A serverless content management system',
  date: '2018-01-30T15:23:44.487Z',
  tags: ['Vue', 'Static webapp', 'Javascript'],
  contentShort: 'How to build a simple yet powerful static CMS system for the web.',
},{
  id: 'manipulating-your-github-repos-directly-through-javascript-and-ajax-calls',
  type: 'article',
  title: 'Manipulating your github repos directly through Javascript and Ajax calls',
  date: '2018-01-28T15:23:44.487Z',
  tags: ['Walkthrough', 'Static webapp', 'Github', 'Javascript'],
  contentShort: 'Read and commit files from the browser.',
}
];



// WEBPACK FOOTER //
// ./src/posts.js